module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle1.png?34b2f844cccbd82f52d77f840b0d5696";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle1.png
// module id = 799
// module chunks = 0